import {
  get,
  post,
  loginApi,
  getDynamicynamic,
  getinfo,
  getFileUseBlobByPost,
} from "@/api/http";

const getParentLibId = (reqdata) => post("/library/getParentLibId", reqdata);
const getLibraryTree = (reqdata) => post("/library/getLibTree", reqdata);
const addLibrary = (reqdata) => post("/library/addLib", reqdata);
const searchLibrary = (reqdata) => post("/library/getLibByCondition", reqdata);
const deleteLibrary = (reqdata) => post("/library/deleteLib", reqdata);
const updateLibrary = (reqdata) => post("/library/setLib", reqdata);
const initTablesLibrary = (reqdata) =>getinfo("/library/getInitTables?libId=", reqdata);
const initTableLibrary = (reqdata) =>getinfo("/library/initTable?libId=", reqdata);
const initReaderCardNo = (reqdata) => get("/reader/initReaderCardNo", reqdata);
const updateReaderCardNo = (reqdata) =>post("/reader/updateReaderCardNo", reqdata);
const initLibraryList = (reqdata) => post("/holding/initLibraryList", reqdata);
const saveReaderCardNo = (reqdata) => post("/reader/saveReaderCardNo", reqdata);
const list = (reqdata) => post("/readerLog/list", reqdata);
const newReaderCard = (reqdata) => post("/handleCard/newReaderCard", reqdata);
const saveReader = (reqdata) => post("/handleCard/saveReader", reqdata);
const duplicateIdCard = (reqdata) => post("/handleCard/duplicateIdNumber", reqdata);
const financeTypeBylibid = (reqdata) =>get("/businessParam/financeTypeBylibid", reqdata);
const libraryByLibid = (reqdata) => get("/librarys/libraryByLibid", reqdata);
const checkIdCardAndName = (reqdata) =>get("/handleCard/checkIdCardAndName", reqdata);
const brushBorrowData = (reqdata) => post("/bookList/syncBorrowData", reqdata);
const brushHistoryDataTmp = (reqdata) => post("/bookList/brushHistoryDataTmp", reqdata);
const updateReaderInfo = (reqdata) => post("/bookList/updateReaderInfo", reqdata);
const updateGeneralRule = (reqdata) => post("/bookList/updateGeneralRule", reqdata);
const deleteInvalidData = (reqdata) => get("/bookList/deleteInvalidData", reqdata);
const syncDepositBill = (reqdata) => post("/bookList/syncDepositBill", reqdata);
const initElasticSearchData = (reqdata) => get("/bookList/initElasticSearchData", reqdata);
const setDeposit = (reqdata) => get("/library/setDeposit", reqdata);
const synHoldingStory = (reqdata) => get("/holding/synHoldingStory", reqdata);
const readerRenew = (reqdata) => get("/reader/readerRenew", reqdata);
const initBookList = (reqdata) => post("/splitting/bookList", reqdata);
const getWMenuButtonAll = (reqdata) => post("/wmenubutton/findByQueryInfo", reqdata);
const getWMenuButtonIdByLibId = (reqdata) => post("/wmenubutton/getWMenubuttonIdByLibid", reqdata);
const setPermission = (reqdata) => post("/wmenubutton/setPermission", reqdata);
const updateESBookListGroupBy = (reqdata) => get("/bookList/elasticSearchBookListGroup", reqdata);
const brushHolding = (reqdata) => post("/bookList/brushHolding", reqdata);
const brushDetailHistoryStatus = (reqdata) => post("/bookList/brushDetailHistoryStatus", reqdata);
const hdifborrowUpdate = (reqdata) => post("/bookList/hdifborrowUpdate", reqdata);

const cardNumberDigitVerification = (reqdata) => post("/businessParam/cardNumberDigitVerification", reqdata);
const findReaderType = (reqdata) => get("/handleCard/findReaderType", reqdata);
const saveReaderLibId = (reqdata) => post("/handleCard/saveReaderLibId", reqdata);
const readerCardLocalNew = (reqdata) => post("/reader/readerCardLocalNew", reqdata);
const gftCertification = (reqdata) => post("/certification/gftCertification", reqdata);

const newLibLaunched = (reqdata) => get("/bookListCount/newLibLaunched",reqdata);

const statisticalResults = (reqdata) => get("/bookListCount/viewStatisticalResults",reqdata);
const syncMarcResults = (reqdata) => post("/bookListCount/getResults",reqdata);
const resetPasswordLibrary = (reqdata) => get("/reader/resetPasswordLibrary",reqdata);

const  getBigScreenUrl = (data)=>get("/librarys/getBigScreenUrl",data);

let baseUrl = "/librarys"

const LogToMaiDa =  (data)=>post(`${baseUrl}/LogToMaiDa`,data);

const getMapKey = (reqdata) => get("/local/getMapKey", reqdata);

const unifiedDocumentTypes = (reqdata) => post("/library/unifiedDocumentTypes", reqdata);

const getByLibid = (reqdata) => post("/library/getByLibid", reqdata);

const getAllCenterType=(reqdata) => get("/library/getAllCenterType", reqdata);

const syncCollectionFullToEs = (reqdata) => post("/libraryCollectionEs/syncFull", reqdata);

const syncMarcData = (reqdata) => post("/librarys/syncMarcData", reqdata);
const marcSyncBook = (reqdata) => post("/librarys/marcSyncBook", reqdata);
const getMarcToBookResult = (reqdata) => get("/librarys/getMarcToBookResult", reqdata);
export default {
  syncMarcResults,
  syncCollectionFullToEs,
  setPermission,
  getWMenuButtonIdByLibId,
  getWMenuButtonAll,
  duplicateIdCard,
  brushBorrowData,
  brushHistoryDataTmp,
  readerRenew,
  updateReaderInfo,
  synHoldingStory,
  initElasticSearchData,
  updateGeneralRule,
  syncDepositBill,
  libraryByLibid,
  deleteInvalidData,
  checkIdCardAndName,
  saveReader,
  financeTypeBylibid,
  newReaderCard,
  list,
  getParentLibId,
  saveReaderCardNo,
  initLibraryList,
  updateReaderCardNo,
  initReaderCardNo,
  getLibraryTree,
  addLibrary,
  searchLibrary,
  deleteLibrary,
  setDeposit,
  updateLibrary,
  initTablesLibrary,
  initTableLibrary,
  initBookList,
  updateESBookListGroupBy,
  brushHolding,
  brushDetailHistoryStatus,
  hdifborrowUpdate,
  cardNumberDigitVerification,
  findReaderType,
  saveReaderLibId,
  readerCardLocalNew,
  gftCertification,
  newLibLaunched,
  statisticalResults,
  getBigScreenUrl,
  resetPasswordLibrary,
  LogToMaiDa,
  getMapKey,
  unifiedDocumentTypes,
  getByLibid,
  getAllCenterType,
  syncMarcData,
  marcSyncBook,
  getMarcToBookResult,
};
